export default __webpack_public_path__ + "static/media/rose-gold.199ac761.png";